export default {
  label: "Flottenverwaltung",
};
